import DynamicAccordion from '../../Component/reusable_components/Accordion/DynamicAccordion'
import DistinctiveFeatureData from '../../Assets/JSON/Aboutjson/Distinctive_Feature.json'

const DistinctiveFeature  = () => {
  return (
    <DynamicAccordion
      data={DistinctiveFeatureData?.DistinctiveFeature_Headings}
      subData={DistinctiveFeatureData.DistinctiveFeature_Data}
      navpath={'distinctivefeaturepage'}
    />
  )
}
export default DistinctiveFeature
